import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card, DataTable, Pagination, Spinner } from '@shopify/polaris';
import axiosRails from '@utils/axios';
import {orderBy} from 'lodash'


const headings=["seller",
  "product",
  "transfer",
  "supplies"
]

class SellerStats extends Component {

  constructor(props) {
    super(props)
    const sellers = props.seller.rows.map( seller => {
      return [
        seller.seller,
        seller.product,
        seller.transfer,
        seller.supplies
      ]
    })
    this.state = {
      page: 1,
      totalPages: props.seller.totalPages,
      order: [['seller'],['asc']],
      rows: sellers,
      sellers_obj: props.seller.rows,
      loading: false,
    }

  }

  render() {
    let { page, totalPages, rows } = this.state
    return(
      <Card title={ I18n.t("dashboard.seller.stats") } >
        <DataTable
          rows={ rows }
          headings={[
            'Seller',// I18n.t("activerecord.attributes.product.status"),
            I18n.t("dashboard.seller.products"),
            I18n.t("dashboard.seller.transfers"),
            I18n.t("dashboard.seller.order_supplies"),
          ]}
          columnContentTypes={[ 'text', 'numeric', 'numeric', 'numeric' ]}
          sortable={[true, true, true, true]}
          onSort={(headingIndex, direction) => this.handleSort(headingIndex, direction)}
          initialSortColumnIndex={0}
        />
        <div className="ph10 pv10 flex flexColumn alignItemsCenter justifyCenter">
          <Pagination
            hasPrevious={ page > 1}
            onPrevious={ () => { this.paginate('prev') }}
            hasNext={ page < totalPages}
            onNext={ () => { this.paginate('next') }}
          />
          {this.state.loading &&
            <div className="ml10">
              <Spinner accessibilityLabel="Loading" size="small" color="teal" />
            </div>
          }
        </div>
      </Card>
    )
  }

  /**
   * Method fired when the user sort the seller table.
   *
   * @param  integer headingIndex
   * @param  string direction    The sort direction (ascending or descending)
   * @return void                 Just update the state with the seller retrieved.
   */

  handleSort= (headingIndex, direction)=>{
    const headingsSort= headings[headingIndex]
    const dir = {
      ascending: 'asc',
      descending: 'desc',
      none: null,
    }[direction];
    this.setState(()=>({
      order: [[headingsSort], [dir]],
      loading: true,
    }),this.rowFilter)
  }


  /**
   * Paginate the sellers in the dashboard
   *
   * @param  string action    The direction of the pagination (prev or next).
   * @return void             Just update the state with the seller retrieved.
   */
  paginate = async (action) => {
    let newPage = this.state.page;
    this.setState({
      loading: true
    })

    switch(action){
      case "next":
        newPage += 1; break;
      case "prev":
        newPage -= 1; break;
      default: // Filter
    }
    let response = await axiosRails.get('/paginate_sellers', {
      params: {
        page: newPage,
        is_pagination: true,
      }
    })
    const { data } = response;
    console.log(data)
    this.setState(()=>({
      sellers_obj: data.rows.seller.rows,
      page: Number(data.page),
      totalPages: data.rows.seller.totalPages,
    }), this.rowFilter)
  }

  rowFilter=()=>{
    const rowOrder = orderBy(this.state.sellers_obj, ...this.state.order)
    const rows= rowOrder.map(seller =>{
      return [
        seller.seller,
        seller.product,
        seller.transfer,
        seller.supplies
      ]
    })
    this.setState({ loading:false, sellers_obj: rowOrder, rows: rows})
  }

}

SellerStats.propTypes = {
  seller: PropTypes.shape({
    rows: PropTypes.array,
  }).isRequired,
};


export default SellerStats;
